export const searchTree = (target: string, tree?: Array<IFarmProductsData>) => {
  const subProducts = tree
    ?.map(x => x.products)
    .flat()
    .map(x => x.subproducts)
    .flat()
    .filter(x => x.title.includes(target));
  const products = tree?.filter(x => x.title.includes(target));
  return {subProducts ,products};
};
